"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AlertOutlet_1 = __importDefault(require("./AlertOutlet"));
exports.default = AlertOutlet_1.default;
